import { defineMessages } from "react-intl";

const errorMessages = defineMessages({
  signup: "Sign Up",

  // sign up errors
  emailExists: "There is already an account using this email address.",
  emailInvalid: "Please check your email address is correct.",
  usernameExists: "Unfortunately this username is already taken.",
  usernameInvalid: "Must use only letters, numbers and '-'.",
  // login errors
  credentialsInvalid: "Username or password is invalid.",
  loginAttemptsExceeded: "Too many login attempts. Please reset your password.",
  emailDuplicate:
    "Looks like your email address is used for multiple accounts. Please log in using your username and update your email address.",
  userStateForbidden:
    "Looks like this account is no longer active. Visit the Help Center for more information.",
  userSuspended:
    "Looks like this account has been suspended. Visit the {helpCenter} for more information.",
  // common errors
  unknownError:
    "Sorry, something went wrong. Please contact customer support so we can help sort this out.",
  captchaInvalid: "Please confirm you are not a robot.",
  openIdTokenInvalid:
    "Your session has expired. Please reload the page and try again.",
  // form validation errors
  required: "Please fill in this field.",
  usernameStartsWithHyphen: "The first character can’t be a '-'.",
  usernameTooShort: "Too short. Must be at least 4 characters long.",
  usernameTooLong: "Too long. Must be less than 15 characters long.",
  passwordTooShort: "Must be at least 8 characters long.",
  passwordHasSpaces: "Must not contain any spaces.",
});

const loginFormMessages = defineMessages({
  title: "Login or signup to your Redbubble account",

  callToAction: "Sign up for 20% off your first order",
  caption:
    "Make favorites lists, track your order history, and more. Check your email for a 20% off coupon after you sign up.",

  signUp: "Sign Up",
  logIn: "Log In",
});

export default errorMessages;
export { loginFormMessages };
